import React, { useState, useEffect } from "react";
import Sidebar_admin from "../Sidebar_Admin/Sidebar_admin";
import axios from "../../../axiosInstance";
import "./ChannelManager.css";

const ChannelManager = () => {
  const [channels, setChannels] = useState([]);
  const [channelName, setChannelName] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState("");

  // Fetch all channels on component mount
  useEffect(() => {
    const fetchChannels = async () => {
      try {
        const response = await axios.get("/api/admin/allchannels");
        setChannels(response.data);
      } catch (error) {
        console.error("Error fetching channels:", error);
      }
    };

    fetchChannels();
  }, []);

  const addChannel = async () => {
    if (!channelName.trim()) return;

    try {
      const response = await axios.post("/api/admin/addchannels", { name: channelName });
      setChannels([...channels, response.data]);
      setChannelName("");
    } catch (error) {
      console.error("Error adding channel:", error);
    }
  };

  const deleteChannel = async (id) => {
    try {
      await axios.delete(`/api/admin/channel/${id}`);
      setChannels(channels.filter((channel) => channel._id !== id)); // Adjust the condition to use _id
    } catch (error) {
      console.error("Error deleting channel:", error);
    }
  };

  const startEditing = (id, name) => {
    setEditingId(id);
    setEditValue(name);
  };

  const saveEdit = async (id) => {
    try {
      const response = await axios.put(`/api/admin/channel/${id}`, { name: editValue });
      setChannels(
        channels.map((channel) =>
          channel._id === id ? { ...channel, name: response.data.name } : channel
        )
      );
      setEditingId(null);
      setEditValue("");
    } catch (error) {
      console.error("Error saving channel edit:", error);
    }
  };

  return (
    <>
      <Sidebar_admin />
      <div className="channel-container">
        <div className="input-container">
          <input
            type="text"
            placeholder="Enter Channel Name"
            value={channelName}
            onChange={(e) => setChannelName(e.target.value)}
          />
          <button className="add-button" onClick={addChannel}>
            Add Channel
          </button>
        </div>

        <table className="channel-table-container">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Channel Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {channels.map((channel, index) => (
              <tr key={channel._id}> {/* Use _id for React key */}
                <td>{index + 1}</td>
                <td>
                  {editingId === channel._id ? (
                    <input
                      type="text"
                      value={editValue}
                      onChange={(e) => setEditValue(e.target.value)}
                    />
                  ) : (
                    channel.name
                  )}
                </td>
                <td className="channel-actions">
                  {editingId === channel._id ? (
                    <button className="edit-button" onClick={() => saveEdit(channel._id)}>
                      Save
                    </button>
                  ) : (
                    <button className="edit-button" onClick={() => startEditing(channel._id, channel.name)}>
                      Edit
                    </button>
                  )}
                  <button className="delete-button" onClick={() => deleteChannel(channel._id)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ChannelManager;
